// extracted by mini-css-extract-plugin
export var cardSelected = "_gq-2";
export var image = "_gq-1";
export var table = "_gq-0";